import { EyeIcon } from "@heroicons/react/16/solid";
import { useState } from "react";
import { api } from "../../../../api";
import { Button } from "../../../../externalComponents/tailwind/button";
import {
  Field,
  Legend,
} from "../../../../externalComponents/tailwind/fieldset";
import {
  Input,
  InputGroup,
} from "../../../../externalComponents/tailwind/input";
import { Text } from "../../../../externalComponents/tailwind/text";

function AlcmeonIntegration({ customer }) {
  const [codeForAlcmeon, setCodeForAlcmeon] = useState(
    customer?.codeForAlcmeon || "",
  );
  const [isCodeForAlcmeonVisible, setIsCodeForAlcmeonVisible] = useState(false);
  const [isGeneratingCodeForAlcmeon, setIsGeneratingCodeForAlcmeon] =
    useState(false);

  if (customer?.apiKey360Dialog) {
    return null;
  }

  return (
    <Field>
      <Legend>Alcmeon</Legend>
      {customer?.alcmeonCompanyId ? (
        <Text>
          Your account is linked to Alcmeon (Company ID:{" "}
          {customer.alcmeonCompanyId})
        </Text>
      ) : codeForAlcmeon ? (
        <div className="flex flex-row">
          <InputGroup className="flex relative items-center">
            <Input
              name="Code for Alcmeon connexion"
              value={codeForAlcmeon}
              disabled
              autoComplete="off"
              type={isCodeForAlcmeonVisible ? "text" : "password"}
            />
          </InputGroup>

          <Button
            color="optionButton"
            className="ml-2"
            onClick={() => setIsCodeForAlcmeonVisible((status) => !status)}
          >
            <EyeIcon />
          </Button>
        </div>
      ) : (
        <Button
          color="secondaryButton"
          loading={isGeneratingCodeForAlcmeon}
          onClick={async () => {
            setIsGeneratingCodeForAlcmeon(true);
            const result = await api.alcmeon.generateCodeForAlcmeon();
            console.log(result);
            setCodeForAlcmeon(result.codeForAlcmeon);
            setIsCodeForAlcmeonVisible(true);
            setIsGeneratingCodeForAlcmeon(false);
          }}
        >
          Generate connexion code
        </Button>
      )}
    </Field>
  );
}

export default AlcmeonIntegration;
